import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output, output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-time-picker',
  standalone:true,
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
  imports:[CommonModule]
})
export class TimePickerComponent implements AfterViewInit{
  showDropdown = false;
  selectedHour: number | null = 3;
  selectedMinute: number | null = 0;
  dropdownStyle: { top?: string; left?: string } = {};
 

  hours: number[] = Array.from({ length: 23 }, (_, i) => i);
  minutes: number[] = Array.from({ length: 60 }, (_, i) => i);

  @Output() totalTime = new EventEmitter<any>();
  @Input () time_saved:any="3 hours  0 minute";

  @ViewChild('timeInput', { static: false }) timeInput!: ElementRef;
  @ViewChild('dropdown', { static: false }) dropdown!: ElementRef;


  ngAfterViewInit() {
    this.timeInput.nativeElement.value = this.time_saved; 
  }

  openTimePicker() {
    this.showDropdown = true;
    const inputRect = this.timeInput.nativeElement.getBoundingClientRect();
    // this.dropdownStyle = {
    //   top: `${inputRect.bottom + window.scrollY}px`,
    //   left: `${inputRect.left + window.scrollX}px`,
    // };
    this.dropdownStyle = {
      top: `${inputRect.top - 260 + window.scrollY}px`, // dropdownHeight is the height of the dropdown
      //left: `${inputRect.left + window.scrollX}px`,
      left:`60px`,
    };
    
  }

  closeTimePicker() {
    this.showDropdown = false;
  }

  selectHour(hour: number) {
    this.selectedHour = hour;
  }

  selectMinute(minute: number) {
    this.selectedMinute = minute;
  }

  setTime(inputField: HTMLInputElement) {
    if (this.selectedHour !== null && this.selectedMinute !== null) {
      let h1='hour';
      let m1='minute';
      if(this.selectedHour>1){
        h1='hours';
      }
      if(this.selectedMinute>1){
        m1='minutes';
      }
      inputField.value = `${this.selectedHour} ${h1}  ${this.selectedMinute} ${m1}`;
      this.totalTime.emit((this.selectedHour * 60 )+this.selectedMinute); // Emit data to parent
      
    }
    this.closeTimePicker();

  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (
      this.timeInput &&
      this.dropdown &&
      !this.timeInput.nativeElement.contains(event.target) &&
      !this.dropdown.nativeElement.contains(event.target)
    ) {
      this.closeTimePicker();
    }
  }
}
